// InvoiceViewContent Component
/* eslint indent: 0, react/jsx-indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import async from 'async'
import ReactSelect from 'react-select'
import classnames from 'classnames'

import currency from '../../../lib/currency.jsx'
import InvoicePhase from '../invoice_phase/invoice_phase.jsx'
import InvoiceViewItemLayer from '../invoice_view_item/invoice_view_itemlayer.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'
import DroppableContainer from '../../../common/common/droppable_container/droppable_container.jsx'
import InvoicePageBreak from '../invoice_view_item/invoice_pagebreak.jsx'
import calculate from '../../../lib/calculate.jsx'
import { getVatRateSelectOptionsFromArray } from '../../../lib/vat_rates_select_options.js'
import { getVatLevels } from '../../../../shared/util/vat'
import { PHASE_TYPES } from '../../../../shared/constants'

class InvoiceViewContent extends Component {
  static get propTypes () {
    return {
      invoice: PropTypes.object,
      budget: PropTypes.object,
      onChange: PropTypes.func,
      onUpdateInvoiceTotal: PropTypes.func,
      onItemCreate: PropTypes.func,
      onItemUpdate: PropTypes.func,
      onItemRemove: PropTypes.func,
      disable: PropTypes.bool,
      createNewActivity: PropTypes.func,
      projectUsers: PropTypes.array,
      vatRate: PropTypes.number,
      teamCountry: PropTypes.string,
      onItemExpenseCreate: PropTypes.func,
      onItemExpenseUpdate: PropTypes.func,
      onItemExpenseDelete: PropTypes.func,
      onRemoveSubItem: PropTypes.func,
      onPhaseRemove: PropTypes.func,
      hasPageBreakTop: PropTypes.bool,
      onUpdateInfo: PropTypes.func,
      projectTitle: PropTypes.string,
      contactName: PropTypes.string,
      onUpdateInvoiceType: PropTypes.func,
      taxRateVatOptions: PropTypes.array,
      onCreateTaxRate: PropTypes.func,
      isQuickbookConnected: PropTypes.bool,
      quickbookItems: PropTypes.array,
      reloadQuickbookItems: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      invoice: null,
      budget: null,
      onChange: null,
      onUpdateInvoiceTotal: null,
      onItemCreate: null,
      onItemUpdate: null,
      onItemRemove: null,
      disable: false,
      createNewActivity: null,
      projectUsers: null,
      vatRate: 0,
      teamCountry: '',
      onItemExpenseCreate: null,
      onItemExpenseUpdate: null,
      onItemExpenseDelete: null,
      onRemoveSubItem: null,
      onPhaseRemove: null,
      hasPageBreakTop: false,
      onUpdateInfo: null,
      projectTitle: '',
      contactName: '',
      onUpdateInvoiceType: null,
      taxRateVatOptions: [],
      onCreateTaxRate: null,
      isQuickbookConnected: false,
      quickbookItems: [],
      reloadQuickbookItems: null
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      dataDate: null,
      editable: false,
      curType: 'expense'
    }

    const {
      showTax,
      showRateTax,
      showRate,
      showActivity
    } = this._getTaxSetting(this.props.invoice, this.props.isQuickbookConnected)

    this.data = {
      invoice: this.props.invoice,
      budget: this.props.budget,
      vats: this.props.invoice.vats,
      isItemDragging: false,
      showTax: showTax,
      showRateTax: showRateTax,
      showRate: showRate,
      showActivity: showActivity,
      type:
        this.props.invoice && this.props.invoice.phaseType
          ? this.props.invoice.phaseType
          : this.getDefaultPhaseType(),
      types: this._getActivityTypes()
    }

    this._references = {
      droppablePagebreakTop: React.createRef()
    }

    this._updateReferences(this.data.budget)
  }

  getDefaultPhaseType () {
    if (this.props.isQuickbookConnected) {
      return 'activity-rate'
    } else {
      return 'activity-rate-tax'
    }
  }

  _getActivityTypes () {
    if (!this.props.isQuickbookConnected) {
      return [
        {
          label: IntlUtil.convertMessage('invoice.view.titleActivityTax'),
          value: 'activity-tax'
        },
        {
          label: IntlUtil.convertMessage('invoice.view.titleActivityRateTax'),
          value: 'activity-rate-tax'
        }
      ]
    } else {
      return [
        {
          label: IntlUtil.convertMessage('invoice.view.titleName'),
          value: 'activity'
        },
        {
          label: IntlUtil.convertMessage('invoice.view.titleActivityRate'),
          value: 'activity-rate'
        }
      ]
    }
  }

  componentDidMount () {
    if (
      this.data.budget &&
      this.data.budget.phases &&
      this.data.budget.phases.length === 0
    ) {
      this._onAddNewPhase()
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount () {
    if (this.props.invoice && this.props.invoice.status === 'Draft') {
      let bAddItem = true
      if (
        this.data.budget &&
        this.data.budget.phases &&
        this.data.budget.phases.length > 0
      ) {
        const phase = this.data.budget.phases[0]
        if (phase.groups && phase.groups.length > 0) {
          const group = phase.groups[0]
          if (group.items && group.items.length > 0) {
            bAddItem = false
          }
        }
      }

      if (bAddItem) {
        this.onAddActivity('expense')
      }
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.invoice) {
      this.data.invoice = nextProps.invoice
    }
  }

  render () {
    return (
      <div className='invoice-viewcontent'>
        {this._renderPhaseList()}
        <InvoiceViewItemLayer
          isDragging={false}
          taxRateVatOptions={[]}
          showRate={this.data.showRateTax}
          showTax={this.data.showTax}
          showRateWithoutTax={this.data.showRate}
          showActivity={this.data.showActivity}
        />
      </div>
    )
  }

  onAddActivity (type) {
    const budget = this.data.budget
    const phase =
      budget && budget.phases && budget.phases.length > 0
        ? budget.phases[budget.phases.length - 1]
        : null

    if (phase) {
      phase.editable = false

      if (phase.groups.length === 0) {
        phase.groups.push({
          id: 0,
          items: []
        })
      }

      const lastIndex = phase.groups.length - 1
      const group = phase.groups[lastIndex]

      const activity = this.props.createNewActivity(
        budget,
        type,
        phase.id,
        group.id
      )
      group.items.push(activity)

      if (type === 'subtotal') {
        phase.groups.push({
          id: lastIndex + 1,
          items: []
        })

        this._onUpdateTotal()
        this._onItemCreate(activity)
      }

      this._onSavePhase(phase)
    }
  }

  reloadItem (item) {
    const budget = this.data.budget
    const phase =
      budget && budget.phases && budget.phases.length > 0
        ? budget.phases[item.phaseNo - 1]
        : null

    if (phase && phase.groups && phase.groups.length > 0) {
      const curGroup = phase.groups[item.groupNo - 1]
      if (curGroup) {
        _.remove(curGroup.items, (obj, _idx) => obj.id === item.id)
      }

      if (curGroup.items.length === 0) {
        _.remove(phase.groups, (group, _idx) => group.id === curGroup.id)
      }
    }

    this._onUpdateTotal()
    this._onSavePhase(phase)
    this._onUpdateInvoiceTotal()
  }

  recalculateInvoiceTotal () {
    this._onUpdateInvoiceTotal()
  }

  _onChange () {
    if (this.props.onChange) {
      this.props.onChange(this.data.budget)
    }
  }

  _filterDiscountPhases (phases = []) {
    return phases.filter(phase => phase.type !== PHASE_TYPES.DISCOUNT) || []
  }

  _getDiscountPhase (phases = []) {
    return phases.find(phase => phase.type === PHASE_TYPES.DISCOUNT)
  }

  _recalculateDiscountPhase (budget) {
    if (!this.props.onItemUpdate) {
      return
    }

    const discountPhase = this._getDiscountPhase(budget.phases)

    if (!discountPhase?.groups?.length) {
      return
    }

    const subtotalWithoutDiscount = this._filterDiscountPhases(budget.phases)
      .reduce((prevValue, currValue) => prevValue + currValue.total, 0)

    discountPhase.total = discountPhase.groups[0].items
      .map(item => this._recalculateDiscountItem(item, subtotalWithoutDiscount))
      .reduce((prevValue, currValue) => prevValue + currValue, 0)
  }

  _recalculateDiscountItem (item, subtotal) {
    if (!this.props.onItemUpdate) {
      return
    }

    item.total = (item.discountPercentage * parseFloat(subtotal)) / 100 || 0

    this.props.onItemUpdate(item, ['total', 'discountPercentage'])

    return item.total
  }

  _onUpdateInvoiceTotal () {
    const invoice = this.data.invoice
    const budget = this.data.budget
    const allItems = []

    if (budget.phases && budget.phases.length > 0) {
      budget.phases.map(phase => {
        if (phase.groups && phase.groups.length > 0) {
          phase.groups.map(group => {
            group.items.map((item, _itemIdx) => {
              allItems.push(item)
            })
          })
        }
      })
    }

    const vatInfo = calculate.calculateVatFromItems(allItems)
    invoice.total = currency.round(vatInfo.total)
    invoice.totalInc = currency.round(vatInfo.totalInc)
    this.data.vats = vatInfo.vats || []

    if (this.props.onUpdateInvoiceTotal) {
      this.props.onUpdateInvoiceTotal(vatInfo.total, vatInfo.totalInc)
    }
  }

  _getVatAmount (amount, vat) {
    if (vat && parseFloat(vat) > 0 && amount !== 0) {
      const vatAmount = (parseFloat(amount) * parseFloat(vat)) / 100
      return currency.round(vatAmount)
    }

    return 0
  }

  addPhase (params = {}) {
    this._onAddNewPhase(params)
  }

  /* Event handlers */
  _onAddNewPhase (params = { type: PHASE_TYPES.REGULAR }) {
    // Remove empty items of previous phases
    const phases = this.data.budget.phases
    if (phases && phases.length > 0) {
      phases.map(phase => {
        if (phase.groups && phase.groups.length > 0) {
          phase.groups.map(group => {
            if (group.items && group.items.length > 0) {
              group.items.map(item => {
                this._onRemoveEmptyItem(phase, group, item)
              })
            }
          })
        }
      })
    }

    const phase = {
      id: phases.length,
      title: '',
      bTitleCompleted: false,
      showAdd: false,
      total: 0,
      spentAmount: 0,
      editable: 'title',
      groups: [
        {
          id: 0,
          items: []
        }
      ]
    }

    if (params.type) {
      phase.type = params.type
    }

    phases.push(phase)
    this._updateReferences(this.data.budget)
    this.setState({ dataDate: new Date() })
  }

  /* Phase events */
  _onChangePhase (phase) {
    this.data.budget.phases.map(obj => {
      if (obj.title === phase.title) {
        obj = phase
      }
    })

    this.setState({ dataDate: new Date() })
  }

  _onSavePhase (phase) {
    this.data.budget.phases.map(obj => {
      if (obj.title === phase.title) {
        obj = phase
      }
    })

    this._onChange()
    this.setState({ dataDate: new Date() })
  }

  _onCopyPhase (phase) {
    const newPhase = _.cloneDeep(phase)
    newPhase.id = this.data.budget.phases.length
    newPhase.title = `${IntlUtil.convertMessage(
      'common.list.copyNewPhasePrefix'
    )} ${newPhase.title || ''}`

    if (newPhase.groups && newPhase.groups.length > 0) {
      newPhase.groups.map(group => {
        if (group.items && group.items.length > 0) {
          group.items.map(item => {
            const newItem = item
            newItem.id = null
            newItem.phaseId = newPhase.id
            newItem.phaseNo = newPhase.id + 1

            this._onItemCreate(newItem)
          })
        }
      })
    }

    this.data.budget.phases.push(newPhase)

    this._updateReferences(this.data.budget)
    this._onUpdateTotal()
    this._onUpdateInvoiceTotal()
    this._recalculateDiscountPhase(this.data.budget)
    this.setState({ dataDate: new Date() })
  }

  _onRemovePhase (phase) {
    _.remove(
      this.data.budget.phases,
      (phaseObj, _phaseIdx) => phaseObj.id === phase.id
    )

    // Remove items
    const removeData = {
      removeItems: [],
      updateItems: [],
      type: 'invoice'
    }

    if (phase.groups && phase.groups.length > 0) {
      phase.groups.map(group => {
        if (group.items && group.items.length > 0) {
          group.items.map(item => {
            removeData.removeItems.push({ id: item.id })
          })
        }
      })
    }

    this.data.budget.phases.map((phase, phaseIdx) => {
      phase.id = phaseIdx

      phase.groups.map((group, groupIdx) => {
        group.items.map((item, itemIdx) => {
          item.phaseNo = phaseIdx + 1
          item.groupNo = groupIdx + 1
          item.orderNo = itemIdx + 1

          removeData.updateItems.push({
            id: item.id,
            data: {
              phaseNo: item.phaseNo,
              groupNo: item.groupNo,
              orderNo: item.orderNo
            }
          })
        })
      })
    })

    // Remove reference
    this._references[`droppablePagebreakPhase-${phase.id}`] = null

    if (this.props.onPhaseRemove) {
      this.props.onPhaseRemove(phase.id, removeData, () => {
        this._recalculateDiscountPhase(this.data.budget)
        this._onUpdateInvoiceTotal()
        this._onUpdateTotal()
      })
    }

    this._onChange()
    this.setState({ dataDate: new Date() })
  }

  _onRemoveEmptyItem (phase, curGroup, _activity) {
    _.remove(
      curGroup.items,
      item => item.title === '' && item.type !== 'subtotal'
    )

    if (curGroup.items.length === 0) {
      _.remove(phase.groups, group => group.id === curGroup.id)
    }
  }

  _onItemCreate (item) {
    if (this.props.onItemCreate) {
      this.props.onItemCreate(item)
    }
  }

  _onItemUpdate (item, attribute) {
    if (this.props.onItemUpdate) {
      this.props.onItemUpdate(item, attribute, () => {
        this._recalculateDiscountPhase(this.data.budget)
        this._onUpdateInvoiceTotal()
      })
    }
  }

  _onItemRemove (item) {
    if (this.props.onItemRemove) {
      this.props.onItemRemove(item, () => {
        this._recalculateDiscountPhase(this.data.budget)

        if (item.type !== 'subtotal') {
          this._onUpdateInvoiceTotal()
        }
      })
    }
  }

  _onUpdateTotal () {
    let budgetTotal = 0
    let budgetTotalSpent = 0
    this.data.budget.phases.map(phase => {
      phase.total = 0
      let groupTotal = 0
      phase.groups.map(group => {
        groupTotal = _.sumBy(group.items, item =>
          item.type === 'subtotal' ? 0 : parseFloat(item.total)
        )

        group.items.map(item => {
          if (item.type === 'subtotal') {
            item.total = groupTotal
          }

          budgetTotalSpent += item.spentAmount ? item.spentAmount : 0
        })

        phase.total += groupTotal
      })

      budgetTotal += phase.total
    })

    this.data.budget.total = budgetTotal
    this.data.budget.totalSpent = currency.round(budgetTotalSpent)
    this._onChange()
  }

  _reArrangeSubtotal () {
    this.data.budget.phases.map(phase => {
      const newGroups = []
      let nextGroupId = 0
      let newGroup = { id: nextGroupId++, items: [] }
      newGroups.push(newGroup)

      phase.groups.map(group => {
        group.items.map((item, _itemIdx) => {
          item.groupId = newGroup.id
          newGroup.items.push(item)

          if (item.type === 'subtotal') {
            newGroup = { id: nextGroupId++, items: [] }
            newGroups.push(newGroup)
          }
        })
      })

      phase.groups = newGroups
    })
  }

  _onChangeType ({ value }) {
    this.data.type = value
    if (value === 'activity-tax') {
      this.data.showActivity = false
      this.data.showRateTax = false
      this.data.showRate = false
      this.data.showTax = true
    } else if (value === 'activity-rate-tax') {
      this.data.showActivity = false
      this.data.showRateTax = true
      this.data.showRate = false
      this.data.showTax = false
    } else if (value === 'activity-rate') {
      this.data.showActivity = false
      this.data.showRateTax = false
      this.data.showRate = true
      this.data.showTax = false
    } else if (value === 'activity') {
      this.data.showActivity = true
      this.data.showRateTax = false
      this.data.showRate = false
      this.data.showTax = false
    }

    this.setState({ dataDate: new Date() })
    if (this.props.onUpdateInvoiceType) {
      this.props.onUpdateInvoiceType(value)
    }
  }

  /* Activity Drag and drop events */
  _onDropPhaseItem () {
    // Save budget
    this.data.isItemDragging = false
    this._removeEmptyDragItems()

    // If subtotal is dropped in some other group, split the group
    this._reArrangeSubtotal()

    // Update the phase total and budget total
    this._onUpdateTotal()

    this._onUpdateItemReorder()
  }

  _getItemPosition (itemDragId) {
    let currItemIdx = 0
    let itemIdx = 0
    this.data.budget.phases.map(phase => {
      phase.groups.map(group => {
        group.items.map(item => {
          if (item.dragId === itemDragId) {
            currItemIdx = itemIdx
          }

          itemIdx++
        })
      })
    })

    return currItemIdx
  }

  _onUpdateItemReorder () {
    const allItems = []
    this.data.budget.phases.map((phase, phaseIdx) => {
      phase.groups.map((group, groupIdx) => {
        group.items.map((item, itemIdx) => {
          item.phaseNo = phaseIdx + 1
          item.groupNo = groupIdx + 1
          item.orderNo = itemIdx + 1

          allItems.push(item)
        })
      })
    })

    async.map(
      allItems,
      (item, mapDone) => {
        this.props.onItemUpdate(
          item,
          ['phaseNo', 'groupNo', 'orderNo'],
          updateErr => {
            mapDone(updateErr)
          }
        )
      },
      _err => {}
    )
  }

  _onDeleteSubtotal () {
    // If subtotal is deleted, merge the groups
    this._reArrangeSubtotal()

    // Update the phase total and budget total
    this._onUpdateTotal()
  }

  _onMoveItem (
    oldPhaseId,
    oldGroupId,
    newPhaseId,
    newGroupId,
    overItemId,
    item,
    originalIndex
  ) {
    const oldPhaseObj = _.find(
      this.data.budget.phases,
      obj => obj.id === oldPhaseId
    )
    let oldGroupObj = null

    if (oldPhaseObj) {
      oldGroupObj = _.find(oldPhaseObj.groups, obj => obj.id === oldGroupId)
    }

    if (!oldGroupObj) {
      return
    }

    const bPageBreak = item.type === 'pagebreak'

    if (oldPhaseId === newPhaseId && oldGroupId === newGroupId) {
      // Find index
      const items = oldGroupObj.items
      const currItemIndex = _.findIndex(
        items,
        obj => obj.dragId === item.dragId
      )
      let overItemIndex = originalIndex

      if (overItemId) {
        overItemIndex = _.findIndex(items, obj => obj.dragId === overItemId)
      }

      // If item is pagebreak
      // If new position is first of phase, or last of phase then dont allow to move item
      const lastItemIdx = items.length - 1
      if (
        bPageBreak &&
        (overItemIndex === 0 || overItemIndex === lastItemIdx)
      ) {
        return
      }

      if (overItemIndex !== currItemIndex) {
        items.splice(currItemIndex, 1)
        items.splice(overItemIndex, 0, item)
      }
    } else {
      const newPhaseObj = _.find(
        this.data.budget.phases,
        obj => obj.id === newPhaseId
      )
      if (newPhaseObj) {
        const newGroupObj = _.find(
          newPhaseObj.groups,
          obj => obj.id === newGroupId
        )
        if (newGroupObj) {
          // Find index
          let overItemIndex = originalIndex
          if (overItemId) {
            overItemIndex = _.findIndex(
              newGroupObj.items,
              obj => obj.dragId === overItemId
            )
          }

          // If item is pagebreak, and If new position is first of phase, dont allow to move item
          // But new position can be last index, since it is new group
          if (bPageBreak && overItemIndex === 0) {
            return
          }

          item.phaseId = newPhaseId
          item.groupId = newGroupId

          _.remove(oldGroupObj.items, obj => obj.dragId === item.dragId)

          if (overItemIndex >= 0) {
            newGroupObj.items.splice(overItemIndex, 0, item)
          }
        }
      }
    }

    this.setState({ dataDate: new Date() })
  }

  _onDragStart (activity) {
    this.data.isItemDragging = true

    this.setState({ dataDate: new Date() })
    if (activity && activity.type === 'pagebreak') {
      window.setTimeout(() => {
        const topRef = this._references.droppablePagebreakTop
        if (
          topRef.current &&
          topRef.current.handler &&
          topRef.current.handler.ref &&
          topRef.current.handler.ref.current
        ) {
          topRef.current.handler.ref.current.show()
        }

        if (this.data.budget && this.data.budget.phases) {
          this.data.budget.phases.map(phase => {
            const phaseRef = this._references[
              `droppablePagebreakPhase-${phase.id}`
            ]
            if (
              phaseRef &&
              phaseRef.current &&
              phaseRef.current.handler &&
              phaseRef.current.handler.ref
            ) {
              phaseRef.current.handler.ref.current.show()
            }
          })
        }
      }, 100)
    }
  }

  _onDragEnd () {
    this.data.isItemDragging = false
    this._removeEmptyDragItems()
    this.setState({ dataDate: new Date() })

    const topRef = this._references.droppablePagebreakTop
    if (
      topRef.current &&
      topRef.current.handler &&
      topRef.current.handler.ref &&
      topRef.current.handler.ref.current
    ) {
      topRef.current.handler.ref.current.hide()
    }

    if (this.data.budget && this.data.budget.phases) {
      this.data.budget.phases.map(phase => {
        const phaseRef = this._references[`droppablePagebreakPhase-${phase.id}`]
        if (
          phaseRef &&
          phaseRef.current &&
          phaseRef.current.handler &&
          phaseRef.current.handler.ref
        ) {
          phaseRef.current.handler.ref.current.hide()
        }
      })
    }
  }

  _removeEmptyDragItems () {
    this.data.budget.phases.map(phase => {
      phase.groups.map(group => {
        _.remove(group.items, obj => obj.isEmptyDragItem)
      })
    })
  }

  refreshInvoice (budget) {
    this._updateReferences(budget)
    this.data.budget = budget
    this.setState({ dataDate: new Date() })
  }

  _onDropPagebreakTop (activity) {
    this._removeActivityFromGroup(activity)
    if (this.props.onUpdateInfo) {
      this.props.onUpdateInfo({ hasPageBreakTop: true }, () => {
        this.setState({ dataDate: new Date() })
      })
    }
  }

  _onDropPagebreakPhase (phaseIdx, activity) {
    this._removeActivityFromGroup(activity)
    if (this.props.onUpdateInfo) {
      this.data.budget.phases[phaseIdx].hasPageBreakTop = true
      this.props.onUpdateInfo({ budget: this.data.budget }, () => {
        this.setState({ dataDate: new Date() })
      })
    }
  }

  _removeActivityFromGroup (activity) {
    const group = this.data.budget.phases[activity.phaseId].groups[
      activity.groupId
    ]
    _.remove(group.items, obj => obj.id === activity.id)

    this._onItemRemove(activity)
  }

  _onRemovePagebreakTop () {
    if (this.props.onUpdateInfo) {
      this.props.onUpdateInfo({ hasPageBreakTop: false }, () => {
        this.setState({ dataDate: new Date() })
      })
    }
  }

  _onRemovePagebreakPhase (phaseIdx) {
    if (this.props.onUpdateInfo) {
      this.data.budget.phases[phaseIdx].hasPageBreakTop = false
      this.props.onUpdateInfo({ budget: this.data.budget }, () => {
        this.setState({ dataDate: new Date() })
      })
    }
  }

  /* Private Functions */
  _renderPhaseList () {
    let _bdgtphasesClass = 'bdgtphases'
    if (
      this.data.budget &&
      this.data.budget.phases &&
      this.data.budget.phases.length === 1 &&
      this.data.budget.phases[0].title !== ''
    ) {
      _bdgtphasesClass = 'bdgtphases bdgtphases_single'
    }

    return (
      <div className='invoiceviewcontentwrap'>
        {this.props.hasPageBreakTop ? (
          <InvoicePageBreak
            disableDrag
            item={{ type: 'pagebreak' }}
            onRemove={this._onRemovePagebreakTop.bind(this)}
          />
        ) : (
          <DroppableContainer
            ref={this._references.droppablePagebreakTop}
            title='invoice.view.dropPagebreakMessage'
            onDropItem={this._onDropPagebreakTop.bind(this)}
          />
        )}
        {this._renderContentHeader()}
        <div className={_bdgtphasesClass}>{this._renderPhases()}</div>
        {this._renderInvoiceTotal()}
      </div>
    )
  }

  _renderContentHeader () {
    let className = 'viewheader'
    if (this.data.showTax) {
      className = 'viewheader tax'
    } else if (this.data.showRateTax) {
      className = 'viewheader rate'
    } else if (this.data.showRate) {
      className = 'viewheader ratewithouttax'
    } else {
      className = 'viewheader activity'
    }

    return (
      <div className={className}>
        <div className='viewcol colname'>
          <ReactSelect
            name='type'
            className='select-alt'
            value={
              _.find(this.data.types, obj => obj.value === this.data.type) ||
              null
            }
            options={this.data.types}
            classNamePrefix='iteminner'
            clearable={false}
            openOnFocus
            onChange={this._onChangeType.bind(this)}
          />
        </div>
        <div className='viewcol colhours'>
          <IntlMessage ident='invoice.view.titleHoursPerUnits' />
        </div>
        <div className='viewcol colrate'>
          <IntlMessage ident='invoice.view.titleRatePerPrice' />
        </div>
        <div className='viewcol colvat'>
          <IntlMessage ident='invoice.view.titleVAT' />
        </div>
        <div className='viewcol colprice'>
          <IntlMessage ident='invoice.view.titlePriceExcl' />
        </div>
      </div>
    )
  }

  _renderPhases () {
    if (!this.data.budget?.phases?.length) {
      return null
    }

    return this._filterDiscountPhases(this.data.budget.phases)
      .map((phase, idx) => {
      return (
        <div className='phasewrap' key={idx}>
          {phase.hasPageBreakTop ? (
            <InvoicePageBreak
              isEstimate
              disableDrag
              item={{ type: 'pagebreak' }}
              onRemove={this._onRemovePagebreakPhase.bind(this, idx)}
            />
          ) : (
            <DroppableContainer
              ref={this._references[`droppablePagebreakPhase-${idx}`]}
              title='invoice.view.dropPagebreakMessage'
              onDropItem={this._onDropPagebreakPhase.bind(this, idx)}
            />
          )}
          {this._renderPhase(phase, idx)}
        </div>
      )
    })
  }

  _renderDiscountPhase () {
    if (!this.data?.budget?.phases.length) {
      return null
    }

    const discountPhase = this._getDiscountPhase(this.data.budget.phases)

    if (!discountPhase) {
      return null
    }

    return (
      <div className='phasewrap'>
        {this._renderPhase(discountPhase, 0, { isDiscountPhase: true })}
      </div>
    )
  }

  _renderPhase (phase, idx, params = { isDiscountPhase: false }) {
    const { budget, isItemDragging, invoice } = this.data
    const vatLevels = getVatRateSelectOptionsFromArray(getVatLevels(this.props.teamCountry, invoice.contactAddress ? invoice.contactAddress.country : null, invoice.contactVatNumber))
    const showDefaultVat = vatLevels.length === 1
    const vatRate = this.props?.vatRate || vatLevels[0].value

    const isFinal = invoice?.status === 'Final'
    const isPaid = invoice?.status === 'Paid'

    return (
      <InvoicePhase
        key={idx}
        phase={phase}
        index={idx}
        budget={budget}
        projectUsers={this.props.projectUsers}
        showDefaultVat={showDefaultVat}
        vatLevels={vatLevels}
        vatRate={vatRate}
        isItemDragging={isItemDragging}
        disabledEdit={this.props.disable}
        isLocked={this._isLocked()}
        isTypeActual={invoice.type === 'based-on-actuals'}
        isCredit={!!invoice.isCredit}
        isQuickbookConnected={this.props.isQuickbookConnected}
        quickbookItems={this.props.quickbookItems}
        onChange={this._onChangePhase.bind(this)}
        onSave={this._onSavePhase.bind(this)}
        onRemove={this._onRemovePhase.bind(this)}
        onUpdateTotal={this._onUpdateTotal.bind(this)}
        onDropItem={this._onDropPhaseItem.bind(this)}
        onMoveItem={this._onMoveItem.bind(this)}
        onItemCreate={this._onItemCreate.bind(this)}
        onItemUpdate={this._onItemUpdate.bind(this)}
        onItemRemove={this._onItemRemove.bind(this)}
        onDragStart={this._onDragStart.bind(this)}
        onDragEnd={this._onDragEnd.bind(this)}
        onDeleteSubtotal={this._onDeleteSubtotal.bind(this)}
        onItemExpenseCreate={this.props.onItemExpenseCreate}
        onItemExpenseUpdate={this.props.onItemExpenseUpdate}
        onItemExpenseDelete={this.props.onItemExpenseDelete}
        onRemoveSubItem={this.props.onRemoveSubItem}
        isFinal={isFinal}
        isPaid={isPaid}
        projectTitle={this.props.projectTitle}
        contactName={this.props.contactName}
        onCopy={this._onCopyPhase.bind(this)}
        onUpdateItemReorder={this._onUpdateItemReorder.bind(this)}
        getItemPosition={this._getItemPosition.bind(this)}
        showTax={this.data.showTax}
        showRate={this.data.showRateTax}
        showRateWithoutTax={this.data.showRate}
        showActivity={this.data.showActivity}
        showVatAutocomplete={this.props.teamCountry === 'US'}
        showLabelType={this.props.teamCountry === 'US'}
        taxRateVatOptions={this.props.taxRateVatOptions}
        onCreateTaxRate={this.props.onCreateTaxRate}
        reloadQuickbookItems={this.props.reloadQuickbookItems}
        isDiscountPhase={params.isDiscountPhase}
      />
    )
  }

  _renderAddPhase () {
    if (this.props.disable) {
      return ''
    }

    const _class = this.state.editable ? 'bdgtaddphase form' : 'bdgtaddphase'
    return (
      <div
        className={_class}
        title={IntlUtil.convertMessage('invoice.view.titleNewPhase')}
      >
        <div className='addaction' onClick={() => this._onAddNewPhase()}>
          <span className='iconcont'>
            <i className='icon icon-budget-add-phase' />
          </span>
          <span className='title'>
            <IntlMessage ident='invoice.view.titleNewPhase' />
          </span>
        </div>
      </div>
    )
  }

  _renderPrice ({ price, message, className }) {
    return (
      <div className={className}>
        <span className='label'>
          <IntlMessage ident={message} />
        </span>
        <div className='viewcol colprice'>
          <h2 className='moneyvalue'>
            <span className='prefix'>{currency.symbol()}</span>
            <span className='value'>
              {currency.format(price)}
            </span>
          </h2>
        </div>
      </div>
    )
  }

  _renderDiscountFee (discountPhase) {
    return (
      <div className='viewsubtotal'>
        <span className='label'>
          {discountPhase.total >= 0
            ? (<IntlMessage ident='invoice.view.fee' />)
            : (<IntlMessage ident='invoice.view.discount' />)}
        </span>
        <div className='viewcol colprice'>
          <h2 className='moneyvalue'>
            <span className='prefix'>{currency.symbol()}</span>
            <span className='value'>
              {this._getAmountValue(discountPhase.total)}
            </span>
          </h2>
        </div>
      </div>
    )
  }

  _renderCreditMessage () {
    return (
      <div className='viewtotalcol message'>
        <div className='info'>
          <span className='iconcont'>
            <i className='icon icon-invoiceinfo'>info</i>
          </span>
          {this._isLocked()
            ? IntlUtil.convertMessage(
                'invoice.view.creditMessageAllowAgain'
              )
            : IntlUtil.convertMessage(
                'invoice.view.creditMessageDontAllowAgain'
              )}
        </div>
      </div>
    )
  }

  _renderInvoiceTotal () {
    const { isQuickbookConnected } = this.props
    const { invoice, budget, showTax } = this.data

    if (!invoice) {
      return null
    }

    const discountPhase = this._getDiscountPhase(budget?.phases)
    const hasVat = (invoice.items || []).find(item => item.vat > 0 && !item.discountPercentage)
    const headerClassName = classnames('viewheader', 'discount', {
      showtax: showTax
    })

    const totalPrice = this._renderPrice({
      price: hasVat && !isQuickbookConnected ? invoice.totalInc : invoice.total,
      message: invoice.showAdditionalInfo ? 'invoice.view.titleTotal' : 'invoice.view.titleTotalIncl',
      className: 'viewtotal'
    })

    if (!discountPhase) {
      return (
        <div className='budfoot'>
          <div className='viewtotalfooter'>
            <div className='viewtotalcol addphase'>
              {!this._isLocked() && this._renderAddPhase()}
            </div>
            <div className='viewtotalcol'>
              {!isQuickbookConnected && hasVat && this._renderPrice({
                price: invoice.total,
                message: 'invoice.view.titleSubTotal',
                className: 'viewsubtotal'
              })}
              {!isQuickbookConnected && hasVat && this._renderVat()}
              {totalPrice}
            </div>
            {invoice.isCredit && invoice.type === 'based-on-actuals' && this._renderCreditMessage()}
          </div>
        </div>
      )
    }

    return (
      <div>
        <div className='budfoot'>
          <div className='viewtotalfooter'>
            <div className='viewtotalcol addphase'>
              {!this._isLocked() && this._renderAddPhase()}
            </div>
            <div className='viewtotalcol'>
              {this._renderPrice({
                price: invoice.total - discountPhase.total,
                message: 'invoice.view.titleSubTotal',
                className: 'viewsubtotal'
              })}
            </div>
          </div>
        </div>

        <div className={headerClassName}>
          <div className='viewcol coldiscountfee'>
            <IntlMessage ident='invoice.view.titleDiscountFee' />
          </div>
          <div className='viewcol colvat'>
            <IntlMessage ident='invoice.view.titleVAT' />
          </div>
          <div className='viewcol colprice'>
            <IntlMessage ident='invoice.view.titlePriceExcl' />
          </div>
        </div>

        <div className='bdgtphases discounts'>
          {this._renderDiscountPhase()}
        </div>

        <div className='budfoot'>
          <div className='bdgtaddphase' />
          <div className='viewtotalfooter'>
            <div className='viewtotalcol'>
              {this._renderDiscountFee(discountPhase)}
              {!isQuickbookConnected && hasVat && this._renderVat()}
              {totalPrice}
            </div>
            {invoice.isCredit && invoice.type === 'based-on-actuals' && this._renderCreditMessage()}
          </div>
        </div>
      </div>
    )
  }

  _renderVat () {
    if (!this.data.vats?.length) {
      return null
    }

    return this.data.vats.map((vatObj, idx) => {
      return (
        <div className='viewvat' key={idx}>
          <span className='label'>
            <IntlMessage ident='invoice.view.titleVAT' /> {vatObj.vat}%
          </span>
          <div className='viewcol colprice'>
            <h2 className='moneyvalue'>
              <span className='value'>
                <PriceText value={vatObj.amount} />
              </span>
            </h2>
          </div>
        </div>
      )
    })
  }

  _getAmountValue (amount) {
    return currency.format(amount)
  }

  _isLocked () {
    return this.props.invoice && this.props.invoice.canInvoiceAgain
  }

  _updateReferences (budget) {
    if (budget && budget.phases) {
      budget.phases.forEach(phase => {
        if (!this._references[`droppablePagebreakPhase-${phase.id}`]) {
          this._references[
            `droppablePagebreakPhase-${phase.id}`
          ] = React.createRef()
        }
      })
    }
  }

  _getTaxSetting (invoice, isQuickbookConnected) {
    let showTax = false
    let showRateTax = false
    let showRate = false
    let showActivity = false

    if (invoice) {
      if (isQuickbookConnected) {
        if (invoice.phaseType === 'activity') {
          showActivity = true
        } else if (
          invoice.phaseType === 'activity-rate-tax' &&
          invoice.phaseType === 'activity-rate'
        ) {
          invoice.phaseType = 'activity-rate'
          showRate = true
        } else {
          invoice.phaseType = 'activity-rate'
          showRate = true
        }
      } else {
        if (invoice.phaseType === 'activity') {
          showActivity = true
        } else if (invoice.phaseType === 'activity-rate-tax') {
          showRateTax = true
        } else if (invoice.phaseType === 'activity-tax') {
          showTax = true
        } else {
          showRateTax = true
          invoice.phaseType = 'activity-rate-tax'
        }
      }
    }

    return { showTax, showRateTax, showRate, showActivity }
  }
}

export default InvoiceViewContent
